import { methods } from 'vue3-vt-notifications/src/notifications.js';

export default methods.notify.bind(methods);
